package pl.decks.personal.components.widgets.tag

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.widgets.tag.TagStylesheet.Chip
import pl.decks.personal.components.widgets.tag.TagStylesheet.Tag

@Composable
fun ChipTag(
    text: String,
    modifier: Modifier = Modifier,
    tagVariant: CssStyleVariant<Tag.Kind>? = null,
    outlineVariant: CssStyleVariant<Chip.Kind>? = null,
) = Box(Chip.Outline.toModifier(outlineVariant).then(modifier)) {
    HashTag(
        text = text,
        variant = tagVariant,
    )
}
